<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-md-6">
        <el-form-item label="Название" prop="title">
          <el-input v-model="form.title" />
          {{ $_ErrorMixin_getError('title') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Ссылка" prop="link">
          <el-input v-model="form.link" />
          {{ $_ErrorMixin_getError('link') }}
        </el-form-item>
      </div>

      <div class="col-md-12">
        <el-form-item label="Изображение" prop="image">
          <SingleImageEdit
            :image-preview="imagePreview"
            @status-change="addImage"
          />
          {{ $_ErrorMixin_getError('image') }}
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'
import ErrorMixin from '@/utils/ErrorMixin'
import SingleImageEdit from '@/components/common/SingleImageEdit.vue'

const defaultValues = {
  title: '',
  link: '',
}

export default {
  name: 'MessengerForm',
  components: { SingleImageEdit },
  mixins: [ErrorMixin],
  data() {
    return {
      form: { ...defaultValues },
      formData: new FormData(),
      rules: {
        title: [
          { required: true, message: 'Пожалуйста, введите название', trigger: 'blur' },
        ],
        link: [
          { required: true, message: 'Пожалуйста, введите ссылку', trigger: 'blur' },
        ],
      },
      editMode: false,
      imagePreview: null,
    }
  },
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateMessenger'
    },
  },
  created() {
    this.fetchMessenger()
  },
  methods: {
    ...mapActions('messengers', [
      'createMessenger',
      'updateMessenger',
      'getMessenger',
      'uploadImage',
    ]),
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            for (const key in this.form) {
              if (key === 'image') continue
              this.formData.append(key, this.form[key])
            }

            if (this.isUpdate) {
              await this.updateMessenger({formData: this.formData, id: this.form.id})
              this.$message.success('Мессенджер успешно обновлен')
            } else {
              await this.createMessenger(this.formData)
              this.$message.success('Мессенджер успешно создан')
            }

            this.$_ErrorMixin_clearErrors()
            this.$router.push({ name: 'MessengersList' })
          } catch (error) {
            this.$_ErrorMixin_handleError(error)
          }
        }
      })
    },
    addImage(image) {
      if (!image) return
      this.formData.append('image', image, image?.name);
    },
    async fetchMessenger() {
      const id = this.$route.params.id
      if (id) {
        const model = await this.getMessenger(id)
        this.fillForm(model)
        this.imagePreview = model.image
      }
    },
    fillForm(model) {
      this.form = {
        ...this.form,
        ...model,
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.messengers-form__upload-image
  margin-bottom: 10px

.messengers-form__preview
  margin-top: 10px
  padding: 10px
  border: 1px solid #dcdfe6
  border-radius: 4px
  display: inline-block

.messengers-form__preview-image
  max-width: 200px
  max-height: 200px
  object-fit: contain
</style>
